// Dependecies
import { createStore, createHook } from 'react-sweet-state';

const initialState = {
  message: '',
};

const actions = {
  getVehicleMap:
    (token) =>
      ({ getState, setState }) =>
        new Promise(async (resolve, reject) => {
          try {
            const options = {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                Authorization: `bearer ${token}`,
              },
            };
            const response = await fetch(
              '/api/bread/jwt/vehicles/static/vehicles_flespiAndPlate',
              options
            );
            const res = await response.json();
            if (response.status !== 200) {
              reject(response);
            } else {
              setState({ vehicles: res.vehicles });
              resolve(getState());
            }
          } catch (e) {
            reject(e);
          }
        }),
  getTripsVehicle:
    (token, idPlate) =>
      ({ getState, setState }) =>
        new Promise(async (resolve, reject) => {
          try {
            const options = {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                Authorization: `bearer ${token}`,
              },
            };
            const response = await fetch(
              `/api/bread/jwt/trips/static/byVehicle?vehicle_id=${idPlate}`,
              options
            );
            const res = await response.json();
            if (response.status !== 200) {
              reject(response);
            } else {
              setState({ trips: res.trips });
              resolve(getState());
            }
          } catch (e) {
            reject(e);
          }
        })
};

const VehiclesMap = createStore({
  initialState,
  actions,
  name: 'useVehiclesMap',
});

export default createHook(VehiclesMap);
